import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Grid,
  Toolbar,
  Typography,
  IconButton,
  List,
  Paper,
  Avatar,
  Menu,
  MenuItem,
  Badge,
} from '@material-ui/core';
import {
  Add as AddIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  Cancel as CancelIcon,
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import { PersonListItem } from 'Components/content/person';
import { DATA_LOAD_STATUS, PAGE_ACTIONS, USER_ROLES } from 'Utils/constants';
import contentLoadingImg from 'Images/content_loading.png';
import { getUsers, selectUser, setUserCurrentAction } from 'Actions/users';
import SearchBar from 'Components/content/searchBar';
import UserDetails from 'Components/content/userViews/details';
import AddUser from 'Components/content/userViews/addUser';
import NoResults from 'Components/content/noResults';
import { openSnackbar } from 'Components/content/notifier';
import Pagination from 'Components/content/pagination';
import ThemedCheckBox from 'Components/buttons/outlinedCheckbox';

const styles = theme => ({
  layoutGrid: {
    width: '100%',
    height: 'auto',
    minHeight: '100vh',
  },
  grow: {
    flexGrow: 1,
  },
  chip: {
    margin: theme.spacing(1),
  },
  contentRoot: {
    padding: theme.spacing(6),
    height: '92vh',
    overflow: 'scroll',
  },
  flexAlignVerticalCenter: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
  },
  contentStatusImg: {
    height: 440,
    width: 440,
  },
  avatar: {
    width: '40px',
    height: '28px',
    borderRadius: '14px',
    opacity: 0.3,
    backgroundColor: '#000000',
  },
  addButton: {
    width: '40px',
    borderRadius: '14px',
    color: '#ffffff',
    backgroundImage: 'linear-gradient(119deg, #c9910c -55%, #f5cb24 100%)',
  },
});

// eslint-disable-next-line new-cap
// const BottomNavigationItems = Enum(
//   'INFO',
//   'MOVES',
//   'FLIGHTS',
//   'HOTELS',
//   'TRANSIT'
// );

class UsersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchMode: false,
      searchTerm: '',
      filters: [],
      anchorEl: null,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.getDetailComponent = this.getDetailComponent.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFilterClose = this.handleFilterClose.bind(this);
    this.handleFilterSelection = this.handleFilterSelection.bind(this);
  }

  componentDidMount() {
    const { getUsers } = this.props;
    const { filters } = this.state;
    getUsers('', 1, filters);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, searchTerm } = this.state;
    const { getUsers } = this.props;
    if (
      JSON.stringify(prevState.filters) !== JSON.stringify(filters) ||
      prevState.searchTerm !== searchTerm
    ) {
      getUsers(searchTerm, 1, filters);
    }
  }

  handleAddUser = e => {
    const { currentAction } = this.props;
    if (currentAction !== PAGE_ACTIONS.EDIT) {
      this.props.setUserCurrentAction(PAGE_ACTIONS.ADD);
    } else {
      openSnackbar({ message: 'Cannot Click', variant: 'info' });
    }
  };

  handleSelectUser(userId) {
    const { currentAction } = this.props;
    if (currentAction !== PAGE_ACTIONS.EDIT) {
      this.props.selectUser(userId);
    } else {
      openSnackbar({ message: 'Cannot Click', variant: 'info' });
    }
  }

  handleSearchMode(searchMode) {
    const { currentAction } = this.props;
    if (currentAction !== PAGE_ACTIONS.EDIT) {
      this.setState({ searchMode });
      if (!searchMode) {
        this.handleSearch('');
      }
    } else {
      openSnackbar({ message: 'Cannot Click', variant: 'info' });
    }
  }

  handleSearch(value) {
    this.setState({ searchTerm: value });
  }

  onPageChange(page) {
    const { getUsers } = this.props;
    const { filters, searchTerm } = this.state;
    getUsers(searchTerm, page, filters);
  }

  handleFilter = event => {
    const { currentAction } = this.props;
    if (currentAction !== PAGE_ACTIONS.EDIT) {
      this.setState({ anchorEl: event.currentTarget });
    } else {
      openSnackbar({ message: 'Cannot Click', variant: 'info' });
    }
  };

  handleFilterClose = () => {
    this.setState({ anchorEl: null });
  };

  handleFilterSelection(filter, checked) {
    let filters = this.state.filters;
    filter = filter === 'ACTIVE';
    if (checked) {
      this.setState({ filters: filters.concat(filter) }, () => {
        return;
      });
    } else {
      let updatedFilters = filters.filter(function(value) {
        return value !== filter;
      });
      this.setState({ filters: updatedFilters }, () => {
        return;
      });
    }
  }

  getDetailComponent() {
    const { currentAction } = this.props;
    switch (currentAction) {
      case PAGE_ACTIONS.VIEW:
        return <UserDetails />;
      case PAGE_ACTIONS.ADD:
        return <AddUser edit={false} />;
      case PAGE_ACTIONS.EDIT:
        return <AddUser edit />;
      case PAGE_ACTIONS.NO_RESULTS:
        return <NoResults handleClick={this.handleAddUser} />;
    }
  }

  render() {
    const {
      contentStatus,
      users,
      currentSelection,
      classes,
      currentPage,
      totalPages,
      hasNextPage,
      hasPrevPage,
    } = this.props;
    const { searchMode, filters, anchorEl } = this.state;
    return (
      <Grid container direction="row">
        <Grid item md={8}>
          <div className={classes.contentRoot}>
            <Toolbar disableGutters={false} variant="regular">
              <Typography variant="h4">All Users</Typography>
              <div className={classes.grow} />
              {searchMode ? (
                <div>
                  <Avatar
                    className={classes.avatar}
                    onClick={() => this.handleSearchMode(false)}
                  >
                    <CancelIcon />
                  </Avatar>
                </div>
              ) : (
                <div>
                  <IconButton
                    aria-label="more"
                    aria-controls="filter"
                    aria-haspopup="true"
                    onClick={this.handleFilter}
                  >
                    <Badge
                      id="filterIcon"
                      badgeContent={filters.length}
                      color="primary"
                    >
                      <FilterListIcon />
                    </Badge>
                  </IconButton>
                  <Menu
                    id="filter"
                    keepMounted
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleFilterClose}
                  >
                    <MenuItem key={'active'}>
                      <ThemedCheckBox
                        value={'ACTIVE'}
                        valueKey={'ACTIVE'}
                        checked={filters.indexOf(true) > -1}
                        onChange={this.handleFilterSelection}
                      />
                    </MenuItem>
                    <MenuItem key={'inactive'}>
                      <ThemedCheckBox
                        value={'INACTIVE'}
                        valueKey={'INACTIVE'}
                        checked={filters.indexOf(false) > -1}
                        onChange={this.handleFilterSelection}
                      />
                    </MenuItem>
                  </Menu>
                  <IconButton
                    id="SearchIcon"
                    disabled={!contentStatus.syncInProgress}
                    onClick={() => this.handleSearchMode(true)}
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    id="addIcon"
                    disableRipple
                    disabled={!contentStatus.syncInProgress}
                    onClick={this.handleAddUser}
                  >
                    <AddIcon className={classes.addButton} />
                  </IconButton>
                </div>
              )}
              <div />
            </Toolbar>
            {searchMode ? (
              <SearchBar onRequestSearch={this.handleSearch} cancelOnEscape />
            ) : null}
            <List className={classNames('contentMarginTop')}>
              {users.map((user, index, arr) => (
                <PersonListItem
                  person={user}
                  name={user.name}
                  designation={user.designation}
                  personId={user.customerId}
                  email={user.email}
                  access={
                    user.access === USER_ROLES.HR_ADMIN
                      ? 'HR Admin'
                      : 'HR Partner'
                  }
                  status={user.isActive ? 'ACTIVE' : 'INACTIVE'}
                  isUser
                  loading={contentStatus.data === DATA_LOAD_STATUS.LOADING}
                  selected={user.customerId === currentSelection}
                  handleSelection={this.handleSelectUser}
                />
              ))}
            </List>
          </div>
          <Grid container direction="row" justify="center" alignItems="center">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              hasNextPage={hasNextPage}
              hasPrevPage={hasPrevPage}
              onPageChange={this.onPageChange}
            />
          </Grid>
        </Grid>
        <Grid item md={4}>
          <Paper square className={classNames('fullHeight')}>
            {contentStatus.data === DATA_LOAD_STATUS.LOADING ? (
              <div
                className={classNames(
                  classes.flexAlignVerticalCenter,
                  'fullHeight',
                  classes.contentRoot
                )}
              >
                <img
                  src={contentLoadingImg}
                  className={classes.contentStatusImg}
                />
                <div className={classNames('contentTopMargin')}> </div>
                <Typography variant="h5" color="textSecondary">
                  Please wait while we are trying to load the content
                </Typography>
              </div>
            ) : (
              this.getDetailComponent()
            )}
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

UsersPage.propTypes = {
  classes: PropTypes.object.isRequired,
  currentUserRole: PropTypes.string.isRequired,
  contentStatus: PropTypes.object.isRequired,
  getUsers: PropTypes.func.isRequired,
  selectUser: PropTypes.func.isRequired,
  setUserCurrentAction: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  currentSelection: PropTypes.string,
  currentAction: PropTypes.symbol,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  hasNextPage: PropTypes.bool,
  hasPrevPage: PropTypes.bool,
};

UsersPage = compose(withStyles(styles, { withTheme: true }))(UsersPage);

const mapStateToProps = state => {
  return { ...state.users, currentUserRole: state.authUser.userProfile.role };
};

const mapDispatchToProps = {
  getUsers,
  selectUser,
  setUserCurrentAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);
